// extracted by mini-css-extract-plugin
module.exports = {"cell":"Rows_cell__3CJhn"};